import DirectionsCarOutlined from "@material-ui/icons/esm/DirectionsCarOutlined";
import LocalShippingOutlined from "@material-ui/icons/esm/LocalShippingOutlined";
import React from 'react';
import { VehicleSize } from 'api';
import IconComponent from 'components/Icons';
import { NO_VEHICLE } from 'constants/icons';
import useStyles from './VehicleIconStyles';
export default function VehicleIcon({
  vehicle
}) {
  const {
    icon
  } = useStyles();
  return /*#__PURE__*/React.createElement(React.Fragment, null, !vehicle && /*#__PURE__*/React.createElement(IconComponent, {
    name: NO_VEHICLE
  }), vehicle && (vehicle.size === VehicleSize.Heavy ? /*#__PURE__*/React.createElement(LocalShippingOutlined, {
    className: icon
  }) : /*#__PURE__*/React.createElement(DirectionsCarOutlined, {
    className: icon
  })));
}